<div class="container" [ngClass]="{ lightBackground: workSpaceIndex !== null }">
  @if (workSpaceIndex !== null) {
    <div class="numberWrapper">
      <span class="number">{{ displayWorkspaceIndex }}</span>
    </div>
  }
  <div class="iconWrapper">
    @if (!isSet && cargoSpaces[0]?.type === 1) {
      <gl-icon [name]="'type-truck'"></gl-icon>
    }
    @if (isSet && cargoSpaces[0]?.type === 1) {
      <gl-icon
        [name]="'trailer'"
        class="trailerIcon"
      ></gl-icon>
    }
    @if (isSet && cargoSpaces[0]?.type === 1) {
      <gl-icon
        [name]="'semi-trailer'"
        class="semiTrailerIcon"
      ></gl-icon>
    }
    @if (cargoSpaces[0]?.type === 2) {
      <gl-icon [name]="'type-container'"></gl-icon>
    }
    @if (cargoSpaces[0]?.type === 3) {
      <gl-icon [name]="'type-other'"></gl-icon>
    }
  </div>
  <div class="textWrapper">
    <div class="text">
      @if (replicatedPalletQuantity > 1) {
        <span class="replicatedQuantity" data-ctx="label-replicated-pallet-quantity">{{ replicatedPalletQuantity }} x</span>
      }
      {{ cargoSpaceName | indexedName }}
    </div>
  </div>
</div>
<div class="textWrapper">
  <div class="dimensions">
    @for (cargoSpace of cargoSpaces; track cargoSpace) {
      <span class="dimensionsText">
        @if (cargoSpace.type === 3) {
          {{ cargoSpace.dimensions.length }} x {{ cargoSpace.dimensions.width }} x
          {{
          getPalletBaseHeight(cargoSpace) | unit: 'length':false
          }}
          {{ cargoSpace.limit | unit: 'weight':false }}
        }
        @if (cargoSpace.type !== 3) {
          {{ cargoSpace.dimensions.length }} x {{ cargoSpace.dimensions.width }} x
          {{ cargoSpace.dimensions.height | unit: 'length':false }}
          {{ cargoSpace.limit | unit: 'weight':false }}
        }
      </span>
    }
  </div>
</div>
@if (workspacesCount === 1) {
  <div class="textWrapper">
    <gl-icon
      [name]="'undo'"
      class="collapse"
      [class.collapseOpen]="!isClosed"
      (click)="collapse()"
    ></gl-icon>
  </div>
}
